<div class="overview-agent-container">
  <div class="overview-agent-note">
    <p>The information below is read-only and cannot be manipulated. To edit it, add it to your agents.</p>
  </div>
  <div class="overview-agent-name-category-container">
    <div class="overview-agent-row">
      <div class="overview-agent-column">
        <div class="overview-agent-info">
          <b>Name: </b>
          <span id="agent-name" class="truncate">{{agent?.name}}</span>
        </div>
        <div *featureFlag="'webSearchConfigurationAgentOverviewAndForm'" class="overview-agent-info">
          <b>Model: </b>
          <span id="agent-model">GPT 4o</span>
        </div>
      </div>
      <div class="overview-agent-column">
        <div class="overview-agent-info">
          <b>Category: </b>
          <span id="agent-category">{{agent?.category}}</span>
        </div>
        <div *featureFlag="'webSearchConfigurationAgentOverviewAndForm'" id="websearch-container"
          class="property-wrapper">
          <div class="websearch-icon"
            [ngClass]="hasWebSearchCapability() ? 'active-web-search' : 'inactive-web-search'">
            <img
              src="assets/icons/web-search/{{ hasWebSearchCapability() ? 'web-search-on.svg' : 'web-search-off.svg' }}"
              alt="Web Search Icon">
            <span>Web search</span>
          </div>
        </div>
      </div>
      <div class="overview-agent-column">
        <div *ngIf="!featureFlags.webSearchConfigurationAgentOverviewAndForm" class="overview-agent-info">
          <b>Created By: </b>
          <span id="agent-created-by">{{agent?.createdBy}}</span>
        </div>
      </div>
    </div>
  </div>

  <div *featureFlag="'webSearchConfigurationAgentOverviewAndForm'" class="overview-agent-info">
    <b>Created By: </b>
    <span id="agent-created-by">{{agent?.createdBy}}</span>
  </div>

  <div class="overview-agent-info">
    <b>Description: </b>
    <span class="overview-agent-description">{{agent?.description}}</span>
  </div>

  <div class="overview-agent-info">
    <b>Instructions: </b>
    <div class="overview-agent-instructions">
      {{agent?.instructions}}
    </div>
  </div>

  <div class="overview-agent-buttons-container">
    <core-button (click)="addToMyAgents()" label="Copy to Personal Agents" type="button" variant="information"
      size="medium" fullspace="true">
    </core-button>
    <core-button (click)="startChat()" label="Chat with Agent" type="button" variant="primary" size="medium"
      fullspace="true">
    </core-button>
  </div>
</div>
